module.exports = __webpack_public_path__ + "std/img/gold.fd4d90e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/daily-draw/gold.webp
// module id = 3uD1
// module chunks = 0 4